export const routes = [
    { name: "Publicaciones", link: "/" },
    { name: "Acerca", link: "/acerca" },
    // { name: "path name", link: "link url" }, like this
  ];